<script >
const __sfc_main = {};
__sfc_main.props = {
  active: Boolean
};
export default __sfc_main;
</script>
<template>
    <svg
        :class="{ rotated: active }"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13 7L7.08936 1L1 7" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
<style lang="less" scoped>
.rotated {
    transform: rotate(180deg);
}
</style>
